











































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({ components: {} })
class ModalConfirmacionReporteCreado extends Vue {
  @Prop({ default: '' }) texto!: string;
  dialog = true;

  cerrarModal() {
    this.$emit('cerrar');
  }
}

export default ModalConfirmacionReporteCreado;
